export default "__VITE_ASSET__6e670cf5__"